import Collapse from "bootstrap/js/dist/collapse";
let toggleFunc = Collapse.prototype.constructor.prototype.toggle;
Collapse.prototype.constructor.prototype.toggle = function () {
    if (event && event.target && $(event.target).hasClass('js-no-collapse')) {
        return;
    }
    toggleFunc.call(this);
}

export default Collapse;